import { render } from "./Potion.vue?vue&type=template&id=fb5549b2"
import script from "./Potion.vue?vue&type=script&lang=js"
export * from "./Potion.vue?vue&type=script&lang=js"

import "./Potion.vue?vue&type=style&index=0&id=fb5549b2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__